import axios from 'axios'
import rollbar from 'utils/rollbar'
import { getAuthUrl } from '../../utils/environment'

interface Params {
  console_token: string
}

interface Response {
  data: {
    dashboard_token: string
  }
}

export const getDashboardToken = async (consoleToken: string) => {
  try {
    const data = await axios.post<Params, Response>(getAuthUrl(), {
      console_token: consoleToken,
    })
    return data?.data?.dashboard_token
  } catch (error) {
    rollbar.error(error)
  }
}
